import {
  IParticleShape,
  ParticleShapeData,
} from "./VolumetricParticles.interface";

export class NetworkParticles implements IParticleShape {
  generate(count: number, size: number): ParticleShapeData {
    const positions = new Float32Array(count * 3);
    const spacing = size / 8;
    const halfSize = size / 2;

    const getGridCoord = () => {
      const steps = Math.floor(size / spacing);
      const idx = Math.floor(Math.random() * (steps + 1));
      return -halfSize + idx * spacing;
    };

    for (let i = 0; i < count; i++) {
      const axis = Math.floor(Math.random() * 3);
      let x, y, z;

      if (axis === 0) {
        x = (Math.random() - 0.5) * size;
        y = getGridCoord();
        z = getGridCoord();
      } else if (axis === 1) {
        x = getGridCoord();
        y = (Math.random() - 0.5) * size;
        z = getGridCoord();
      } else {
        x = getGridCoord();
        y = getGridCoord();
        z = (Math.random() - 0.5) * size;
      }

      positions[i * 3] = x;
      positions[i * 3 + 1] = y;
      positions[i * 3 + 2] = z;
    }
    return { positions };
  }
}
